/* dondini — Resultados: anima as barras e os números quando entram na tela */
if (!customElements.get('dondini-results')) {
  customElements.define(
    'dondini-results',
    class DondiniResults extends HTMLElement {
      connectedCallback() {
        this.played = false;
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) this.play();
              });
            },
            { threshold: 0.35 }
          );
          this.observer.observe(this);
        } else {
          this.play();
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      play() {
        if (this.played) return;
        this.played = true;

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.querySelectorAll('[data-fill]').forEach((fill) => {
          const target = parseFloat(fill.dataset.target) || 0;
          requestAnimationFrame(() => {
            fill.style.width = `${target}%`;
          });
        });

        this.querySelectorAll('[data-target]').forEach((el) => {
          if (el.hasAttribute('data-fill')) return;
          const target = parseFloat(el.dataset.target) || 0;
          if (reduce) {
            el.textContent = `${target}%`;
            return;
          }
          const duration = 1200;
          const startTime = performance.now();
          const step = (now) => {
            const progress = Math.min((now - startTime) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            el.textContent = `${Math.round(eased * target)}%`;
            if (progress < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        });
      }
    }
  );
}
